<template lang="pug">
#bloco-tabela-relatorio-nao-enviado
    h1 {{ $t('mensagens.relatorioRastreabilidade.cadastro.listagemTerritorios') }}
    el-table(
        :key="listagemTableKey('relatorio-nao-enviados', paginacaoDataTerritoriosNaoEnviados, paginaAtual)",
        :data='paginacaoDataTerritoriosNaoEnviados',
        stripe,
        style='width: 100%',
        v-loading='carregandoTabela || carregando',
        @selection-change='handleSelectionChange',
        @sort-change='sortChangeRequest',
        :default-sort='{ prop: "nome", order: "ascending" }'
    )
        el-table-column#remover-certificacao-nao-enviada(
            type='selection',
            v-if='removendo',
            align='center'
        )
        el-table-column(
            prop='codigoCar',
            label='CAR',
            sortable='custom',
            width='350'
        )
            template(slot-scope='scope')
                p {{ scope.row.codigoCar }}

        el-table-column(prop='cpfCnpj', label='CPF/CNPJ', sortable='custom')
            template(slot-scope='scope')
                p {{ formatCpfCnpj(scope.row.cpfCnpj) }}

        el-table-column(
            prop='volumeAdicionado',
            :label='$t("mensagens.relatorioRastreabilidade.cadastro.volumeAdicionado")',
            sortable='custom'
        )
            template(slot-scope='scope')
                span {{ formatarVolume(scope.row.volumeAdicionado) }}

        el-table-column(
            prop='anoSafra',
            :label='$t("mensagens.comuns.safra") + "/" + $t("mensagens.comuns.safrinha")'
        )
        el-table-column(
            prop='dataAnalise',
            :label='$t("mensagens.relatorioRastreabilidade.cadastro.dataUltimaAnalise")'
        )
        el-table-column(
            prop='nivelAlerta',
            :label='$t("mensagens.comuns.situacao")',
            sortable='custom',
            width='150'
        )
            template(slot-scope='scope')
                span.staus(
                    :class='statusDiagnostico[scope.row.nivelAlerta] ? statusDiagnostico[scope.row.nivelAlerta].corClasse : ""'
                ) {{ statusDiagnostico[scope.row.nivelAlerta] ? statusDiagnostico[scope.row.nivelAlerta].status : '' }}

        el-table-column(
            :label='$t("mensagens.comuns.acoes")',
            align='center',
            width='100'
        )
            .template(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='visualizarAnaliseElegibilidade(scope.row)'
                        ) {{ $t('mensagens.relatorioRastreabilidade.cadastro.visualizarAnaliseElegibilidade') }}

                        el-dropdown-item(
                            icon='el-icon-delete',
                            @click.native='removerTerritorio(scope.row.idLinha)'
                        ) {{ $t('mensagens.comuns.remover') }}
        template(slot='empty')
            el-empty(:description='$t("mensagens.comuns.semDados")')

    .tabela-tabela-relatorio-nao-enviado__paginacao
        .spans-paginacao
            span.spans-paginacao--imoveis
                | {{ relatoriosNaoEnviados.length }} {{ relatoriosNaoEnviados.length <= 1 ? ` ${$t('mensagens.relatorioRastreabilidade.cadastro.imovel')}` : ` ${$t('mensagens.relatorioRastreabilidade.cadastro.imoveis')}` }}

            span.spans-paginacao--toneladas
                | {{ somarVolumesTerritorio() }} {{ volumeTotalAdicionado > 1 ? $t('mensagens.relatorioRastreabilidade.cadastro.toneladas') : $t('mensagens.relatorioRastreabilidade.cadastro.tonelada') }}

            // span.spans-paginacao--toneladas
            //    | {{ volumeDisponivelContrato() }} volume disponível (t)

        el-pagination(
            background,
            :page-size='pageCount',
            :pager-count='pageCount',
            :current-page.sync='paginaAtual',
            layout='prev, pager, next',
            :total='relatoriosNaoEnviados.length',
            @current-change='mudarPagina'
        )
</template>

<script>
import formatters from '@/utils/formatters';
export default {
    name: 'TabelaNaoEnviadosRelatorioRastreabilidade',

    props: {
        relatoriosNaoEnviados: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: false
        },
        volumeContrato: {
            type: Number,
            required: false,
            default: 0
        },
        carregando: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            territoriosSelecionados: [],
            carregandoTabela: false,
            paginaAtual: 1,
            pageCount: 11,
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.conforme'
                    )
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inconforme'
                    )
                }
            },
            volumeTotalAdicionado: ''
        };
    },

    computed: {
        paginacaoDataTerritoriosNaoEnviados() {
            const inicio = (this.paginaAtual - 1) * this.pageCount;
            const fim = inicio + this.pageCount;

            return this.relatoriosNaoEnviados.slice(inicio, fim);
        }
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.updateStatusDiagnostico();
        }
    },

    methods: {
        formatarCar(car) {
            return formatters.reduzirCar(car);
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(
                cpfCnpj.toString().replace(/\D/g, '')
            );
        },

        formatarVolume(volume) {
            return Number(volume).toString().replace('.', ',');
        },

        async handleSelectionChange(territorios) {
            this.territoriosSelecionados = territorios;

            var idsTerritorios = this.territoriosSelecionados.map(
                territorio => territorio.idLinha
            );
            this.emiteRemoverTerritorioLote(idsTerritorios);
        },

        emiteRemoverTerritorioLote(idsTerritorios) {
            this.$emit('removerTerritorioLote', idsTerritorios);
        },

        async removerTerritorio(territorios) {
            try {
                const result = await this.$messageBox.confirm(
                    this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.desejaRemoverTerritorioSelecionado'
                    ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                if (result) {
                    this.carregandoTabela = true;

                    if (!Array.isArray(territorios)) {
                        territorios = [territorios];
                    }

                    let quantidadeDeletados = 0;

                    territorios.forEach(id => {
                        let indice = this.relatoriosNaoEnviados.findIndex(
                            obj => obj.idLinha === id
                        );
                        if (indice !== -1) {
                            this.relatoriosNaoEnviados.splice(indice, 1);
                            quantidadeDeletados++;
                        }
                    });

                    this.paginaAtual = 1;

                    setTimeout(() => {
                        this.carregandoTabela = false;
                    }, 500);

                    if (quantidadeDeletados >= 1) {
                        this.$notify.success(
                            this.$t(
                                'mensagens.relatorioRastreabilidade.cadastro.territorioRemovido'
                            )
                        );
                    }

                    let bloqueiEdicao = true;
                    if (!this.relatoriosNaoEnviados.length) {
                        bloqueiEdicao = false;
                    }
                    this.$emit('bloqueioDeEdicao', bloqueiEdicao);
                }
            } catch (error) {}
        },

        somarVolumesTerritorio() {
            const soma = this.relatoriosNaoEnviados.reduce(
                (total, item) =>
                    total +
                    parseFloat(
                        item.volumeAdicionado.toString().replace(',', '.')
                    ),
                0
            );
            this.volumeTotalAdicionado = Number(soma.toFixed(3))
                .toString()
                .replace('.', ',');

            this.$emit('volumeTotalAdicionado', this.volumeTotalAdicionado);
            this.$emit('volumeTotalAdicionado', this.volumeTotalAdicionado);
            return this.volumeTotalAdicionado;
        },

        volumeDisponivelContrato() {
            var volumeTotalAdicionadoConvertido = parseFloat(
                this.volumeTotalAdicionado.replace(',', '.')
            );
            var volumeDisponivelContrato =
                this.volumeContrato - volumeTotalAdicionadoConvertido;

            if (
                !isNaN(this.volumeContrato) &&
                !isNaN(volumeTotalAdicionadoConvertido)
            ) {
                volumeDisponivelContrato = Number(
                    (
                        this.volumeContrato - volumeTotalAdicionadoConvertido
                    ).toFixed(3)
                );
                return volumeDisponivelContrato.toString().replace(/\./g, ',');
            } else {
                return 0;
            }
        },

        sortChangeRequest(column) {
            this.relatoriosNaoEnviados.sort((a, b) => {
                let valorA = a[column.prop];
                let valorB = b[column.prop];

                if (column.prop === 'codigoCar') {
                    valorA = valorA.toLowerCase();
                    valorB = valorB.toLowerCase();

                    if (valorA < valorB) {
                        return column.order === 'ascending' ? -1 : 1;
                    }
                    if (valorA > valorB) {
                        return column.order === 'ascending' ? 1 : -1;
                    }
                }

                if (column.prop === 'cpfCnpj') {
                    if (valorA < valorB) {
                        return column.order === 'ascending' ? -1 : 1;
                    } else if (valorA > valorB) {
                        return column.order === 'ascending' ? 1 : -1;
                    }
                }

                if (column.prop === 'volumeAdicionado') {
                    const numeroA = parseFloat(
                        a.volumeAdicionado.replace(/,/g, '')
                    );
                    const numeroB = parseFloat(
                        b.volumeAdicionado.replace(/,/g, '')
                    );
                    if (column.order === 'ascending') {
                        return numeroA - numeroB;
                    } else {
                        return numeroB - numeroA;
                    }
                }

                if (column.prop === 'anoSafra') {
                    if (valorA < valorB) {
                        return column.order === 'ascending' ? -1 : 1;
                    } else if (valorA > valorB) {
                        return column.order === 'ascending' ? 1 : -1;
                    }
                }

                if (column.prop === 'nivelAlerta') {
                    valorA = a.situacao.toLowerCase();
                    valorB = b.situacao.toLowerCase();

                    if (valorA < valorB) {
                        return column.order === 'ascending' ? -1 : 1;
                    }
                    if (valorA > valorB) {
                        return column.order === 'ascending' ? 1 : -1;
                    }
                }

                return 0;
            });
            this.paginaAtual = 1;
        },

        mudarPagina(currentPage) {
            this.paginaAtual = currentPage;
        },

        visualizarAnaliseElegibilidade(row) {
            this.$emit('visualizarAnaliseElegibilidade', row);
        },

        updateStatusDiagnostico() {
            this.statusDiagnostico.BAIXO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.conforme'
            );
            this.statusDiagnostico.MEDIO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.MEDIO_ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inconforme'
            );
        }
    }
};
</script>

<style lang="scss">
#bloco-tabela-relatorio-nao-enviado {
    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }

    .car-hiden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-tabela-relatorio-nao-enviado__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }

        .spans-paginacao {
            display: flex;
            gap: 21px;
            color: #183b57;
            font-weight: bold;
        }
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .el-checkbox__inner {
        margin-left: -10px;
    }

    .status-amarelo {
        color: #bfae19;
    }

    .status-laranja {
        color: var(--warning);
    }

    .status-danger {
        color: var(--danger);
    }

    .status-sucess {
        color: var(--green);
    }

    .status-elegibilidade-tabela-cars__bloco {
        display: flex;
        align-items: center;
    }
}
</style>
